import { Header } from '@/components/Header/Header';
import { BottomBar } from '@/components/BottomBar/BottomBar';

/**
 * Экран-саб 2.8.3 «Отзывы партнёра» (Блок 8, ADR-0080, Фаза D3).
 *
 * Живёт на `/partners/:id/reviews`. В D3 — ТОЛЬКО пустое состояние «Отзывов пока
 * нет» (P-021 empty). Реальные отзывы + эндпоинт `GET /api/partners/:id/reviews` —
 * Фаза E; здесь его НЕ дёргаем (эндпоинта пока нет). Форма «Что улучшить» 2.8.4 —
 * тоже Фаза E.
 *
 * Layout shell P-046, дизайн-система bg-canvas/bg-card (P-038), text-ink (P-039),
 * Manrope (P-043), палитра токенами (P-045). «Назад» к карточке — история
 * (BottomBar/Header, P-036). VideoButton НЕ дублируется (дочерний экран, P-040).
 */
export function PartnerReviews() {
  return (
    <main className="min-h-screen flex flex-col bg-canvas">
      <Header title="Отзывы" />
      <section className="flex-1 overflow-y-auto flex items-center justify-center p-6">
        <p className="font-display text-h2 text-ink text-center m-0">Отзывов пока нет</p>
      </section>
      <BottomBar />
    </main>
  );
}
